// extracted by mini-css-extract-plugin
export default {"cta":"_F-z","disabled":"aG-z"};